/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useMemo, useState } from 'react';

import { useGetMemberSignUpFormQuery } from 'store/api/version-api.slice';

import EditSignUpFormDialog from './EditSignUpFormDialog';
import { styles } from './styles';

const MemberSignUpView = () => {
	const [formOpen, setFormOpen] = useState(false);

	const { data: memberSignUpFormResponse = {} } = useGetMemberSignUpFormQuery();

	const memberSignUpForm = useMemo(() => memberSignUpFormResponse.results || [], [memberSignUpFormResponse.results]);

	const toggleMemberForm = () => setFormOpen(prev => !prev);

	return (
		<Box sx={styles.root}>
			<Box>
				<Paper elevation={2}>
					<Toolbar>
						<Typography component={'span'} variant="h6" color="primary" sx={styles.title}>
							MEMBER SIGN UP FORM
						</Typography>
					</Toolbar>
					<Divider />
					<Box sx={styles.content}>
						{memberSignUpForm.map((form, index) => (
							<Box key={`member-form-${index}`} sx={{ display: 'flex', flexDirection: 'column' }}>
								<Typography component={'span'} variant={'h6'}>
									Embeddable Code:
								</Typography>
								<Typography component={'span'} sx={styles.code_block}>
									{form.last_form_code}
								</Typography>
							</Box>
						))}
						<Box
							sx={{
								padding: '8px',
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'space-between'
							}}
						>
							<Button
								color="primary"
								variant={'contained'}
								sx={{ marginBottom: '8px' }}
								onClick={toggleMemberForm}
							>
								Edit Sign up form
							</Button>
						</Box>
					</Box>
				</Paper>
			</Box>
			<EditSignUpFormDialog formOpen={formOpen} toggleMemberForm={toggleMemberForm} setFormOpen={setFormOpen} />
		</Box>
	);
};

export default MemberSignUpView;
